import script from "./MiNTNewsDetailCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MiNTNewsDetailCom.vue?vue&type=script&setup=true&lang=js"

import "./MiNTNewsDetailCom.vue?vue&type=style&index=0&id=41a7ef8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a7ef8e"]])

export default __exports__